import React from "react";
import { Button, Modal } from "semantic-ui-react";
import { useToasts } from "react-toast-notifications";
import { ToastStatuses } from "../../../../../../components/global_components/Toast";
import { SubscriptionGroup } from "../../../../../../queries/notify";
import { useNotifySubscriberContactMethodRemoveFromGroup } from "../../../../hooks/useNotifySubscriberContactMethodRemoveFromGroup";

export function RemoveSubscriberContactMethodModal({
  subscriberContactMethodId,
  group,
  isOpen,
  close,
  onSubmit = () => {},
}: {
  subscriberContactMethodId?: number;
  group: SubscriptionGroup | null;
  isOpen: boolean;
  close: () => void;
  onSubmit?: () => void;
}) {
  const { addToast } = useToasts();

  const {
    removeSubscriberContactMethodFromGroup,
    isDeleteNotifySubscriberContactMethodSubscriptionPreferencesLoading,
  } = useNotifySubscriberContactMethodRemoveFromGroup();

  return (
    <Modal open={isOpen} onClose={close} closeIcon size='tiny'>
      <Modal.Header>Remove from {group?.visibility} Group?</Modal.Header>
      <Modal.Content>
        {group?.name} is a {group?.visibility} subscription group. Once you remove this contact method, they will not
        receive notifications from this group
        {group?.visibility === "Private" ? " and will be unable to toggle them back on" : ""}. You can re-invite them to
        restore access
        {group?.visibility === "Private"
          ? "."
          : ", or they can subscribe by navigating directly to a notification from this group."}
      </Modal.Content>
      <Modal.Actions>
        <Button content='Cancel' secondary onClick={close} />
        <Button
          content='Remove'
          primary
          disabled={isDeleteNotifySubscriberContactMethodSubscriptionPreferencesLoading}
          loading={isDeleteNotifySubscriberContactMethodSubscriptionPreferencesLoading}
          onClick={async () => {
            if (!subscriberContactMethodId || !group) return;
            await removeSubscriberContactMethodFromGroup(subscriberContactMethodId, group?.id);

            close();
            addToast(`Removed Subscriber from ${group?.name}`, {
              appearance: ToastStatuses.Success,
              autoDismiss: true,
            });
            onSubmit();
          }}
        />
      </Modal.Actions>
    </Modal>
  );
}
